import { render, staticRenderFns } from "./editMenu.vue?vue&type=template&id=82cddc9a&scoped=true"
import script from "./editMenu.vue?vue&type=script&lang=js"
export * from "./editMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82cddc9a",
  null
  
)

export default component.exports